module.exports = __webpack_public_path__ + "static/img/wx.6000b9e3.jpeg";